<template>
  <nav class="tw-bg-white tw-flex tw-border-b tw-border-solid tw-border-gray-lighter tw-h-20 tw-z-50" :class="{ 'typeahead-on': typeaheadOn, 'sticky-top': isSticky, 'tour-padding': !isSticky }">
    <div class="tw-max-w-7xl tw-w-full tw-flex tw-relative tw-mx-auto tw-px-0.5 xs:tw-px-4 tw-py-3 sm:tw-px-6 lg:tw-px-4">
      <div class=" tw-flex tw-justify-between tw-w-full">
        <TheNavbarTypeahead @typeaheadFocusChanged="onTypeaheadFocusChanged" />
        <div class="tw-absolute tw-left-1/2 tw-transform tw--translate-x-1/2 tw-inline-block tw-top-4">
          <a :href="linkToRebtelCom">
            <TheLogo />
          </a>
        </div>
        <div class="tw-flex">
          <slot></slot>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import { EventBus } from '@/utils/eventBus'
import TheLogo from '@/components/TheLogo'
import TheNavbarTypeahead from '@/components/TheNavbarTypeahead'

export default {
  components: {
    TheLogo,
    TheNavbarTypeahead
  },
  data () {
    return {
      typeaheadOn: false,
      isSticky: true
    }
  },
  computed: {
    linkToRebtelCom () {
      const avalibleLocales = ['en', 'es', 'de', 'fr']
      let locale = 'en'
      if (avalibleLocales.includes(this.$route.params.locale)) {
        locale = this.$route.params.locale
      }
      return process.env.WWW_URL + '/' + locale + '/'
    }
  },
  async created () {
    this.preventStickyNavbarDuringTour()
  },
  methods: {
    onTypeaheadFocusChanged (value) {
      this.typeaheadOn = value
    },
    preventStickyNavbarDuringTour () {
      EventBus.onTourStartEvent(() => {
        this.isSticky = false
      })
      EventBus.onTourEndEvent(() => {
        this.isSticky = true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TheNavbar.vue